<div class="version-select" *ngIf="footerVersion && footerVersion.versionen && footerVersion.versionen.length > 1">
  <div class="prev-spacer">
    <div class="prev" *ngIf="prevVersion" (click)="navigateToVersion(prevVersion)">
      <mat-icon>navigate_before</mat-icon>
      <div>{{getVersionLabel(prevVersion, footerVersion.type)}}</div>
    </div>
  </div>
  <div class="current" [matMenuTriggerFor]="versmenu">
    <div class="text-box">
      <mat-icon class="aktuell-icon right-margin" *ngIf="aktuellIdx === 0">verified</mat-icon>
      <span
        class="bold right-margin">{{getVersionLabel(getAktuellItem(), footerVersion.type)}}</span>{{getLabel(getAktuellItem(), footerVersion.type)}}
    </div>
    <mat-icon>expand_less</mat-icon>
  </div>
  <div class="next-spacer">
    <div class="next" *ngIf="nextVersion" (click)="navigateToVersion(nextVersion)">
      <div>{{getVersionLabel(nextVersion, footerVersion.type)}}</div>
      <mat-icon>navigate_next</mat-icon>
    </div>
  </div>
  <mat-menu #versmenu="matMenu" class="max-height-menu wide-menu">
    <div (click)="clickMenu($event, item)" mat-menu-item
         *ngFor="let item of footerVersion.versionen; let i = index"
         [ngClass]="{'active-item': footerVersion.currentVersion ? isAktuell(item) : i === 0}">
      <h5 [ngClass]="{'mdc-theme-success': i === 0}" class="vers-row">
        <mat-icon *ngIf="getIcon(item, footerVersion.type, i === 0)"
                  [class]="getIconClass(item, footerVersion.type, i === 0)">{{getIcon(item, footerVersion.type, i === 0)}}</mat-icon>
        <span
          class="bold right-margin">{{getVersionLabel(item, footerVersion.type)}}</span>{{getLabel(item, footerVersion.type, true)}}
      </h5>
    </div>
  </mat-menu>
</div>
